import './sideBarItem.css'

// o sideBarItem é o item do menu lateral que redireciona para uma página

function SideBarItem({ nome, icon, path }) {
  return (
    <li className="list-itens" id="list">
      <div className="item collapsed"
        data-bs-target={"#" + nome + "filho"}
        data-bs-toggle="collapse">
        {icon}
        <span>{nome}</span>
        <i className="bi bi-chevron-down"></i>
      </div>
      <ul id={nome + "filho"}
        className="sub-item collapse"
        data-bs-parent="#list">
        <li>
          <a className="sub-item-intern"
            href={"/" + path + "-notificacao"}>
            <i className="bi bi-bell"></i>
            {/*aqui é onde vai colocar o nome do sub menu, ou seja, oq vai aparecer quando clicar no botao*/}
            <span>Desfechos</span>
          </a>
        </li>
        <li>
          <a className="sub-item-intern"
            href={"/" + path + "-mapas"}>
            <i className="bi bi-map"></i>
            <span>Mapas</span>
          </a>
        </li>
        <li>
          <a className="sub-item-intern"
            href={"/TB-comparativos"}>
            <i className="bi bi-bar-chart-steps"></i>
            <span>Comparativos</span>
          </a>
        </li>
        <li>
          <a className="sub-item-intern"
            href={"/TB-ranking"}>
            <i className="bi bi-trophy"></i>
            <span>Ranking</span>
          </a>
        </li>
        <li>
          <a className="sub-item-intern"
            href={"/TB-series"}>
            <i className="bi bi-graph-up-arrow"></i>
            <span>Análise Preditiva</span>
          </a>
        </li>
      </ul>
    </li>
  );
};

export default SideBarItem;
